// =============================================================================
// Calibrator Types
// =============================================================================

export const CALIBRATOR_TYPES: Record<number, string> = {
  0: 'SI Units',
  1: 'Primary',
  2: 'Secondary',
  3: 'Reference',
  4: 'Working Standard',
};

/** Calibrator document from V4 API (PostgreSQL) */
export interface Calibrator {
  id: string;
  mongoCalibratorId: string;
  accountId: string | null;
  accountName: string | null;
  name: string;
  enabled: boolean;
  type: number;
  manufacturer: string | null;
  model: string | null;
  serialNumber: string | null;
  unit: string;
  resolution: string;
  measurementUncertainty: string;
  certNumber: string;
  certIssueDate: string;
  certDueDate: string;
  createdAt: string;
  updatedAt: string;
}

// =============================================================================
// Response Types
// =============================================================================

export interface CalibratorsListResponse {
  calibrators: Calibrator[];
  total: number;
  page: number;
  pageLength: number;
}

// =============================================================================
// Filter Types
// =============================================================================

export interface CalibratorsFilters {
  search?: string;
  enabled?: string;
  page?: number;
  pageLength?: number;
  sortKey?: string;
  sortDirection?: number;
}

// =============================================================================
// Input Types
// =============================================================================

export interface CreateCalibratorInput {
  name: string;
  enabled: boolean;
  type: number;
  manufacturer?: string;
  model?: string;
  serial_number?: string;
  unit: string;
  resolution: number;
  measurement_uncertainty: number;
  cert_number: string;
  cert_issue_date: string;
  cert_due_date: string;
}

export interface UpdateCalibratorInput extends Partial<CreateCalibratorInput> {
  _id: string;
}
